import {booleanAttribute, Directive, DoCheck, inject, Input} from '@angular/core';
import {Select} from 'primeng/select';

/**
 * En PrimeNG 16 un dropdown sin placeholder ponía la primera opción en el modelo cuando el valor era nulo
 * (autoDisplayFirst, activo por defecto): al llegar las opciones, al limpiar el formulario o al iniciar. Desde la 17
 * solo lo hace al iniciar (las opciones que llegan después se muestran pero no se asignan) y la 21 lo elimina.
 * Muchos formularios cuentan con ese valor; se desactiva con [autoDisplayFirst]="false", como antes.
 */
@Directive({
    selector: 'p-select',
    standalone: true
})
export class SelectAutoDisplayFirstDirective implements DoCheck {
    @Input({transform: booleanAttribute}) autoDisplayFirst = true;

    private readonly select: any = inject(Select);
    private listo = false;
    private esperando = false;

    ngDoCheck(): void {
        if (this.listo) {
            this.mostrarPrimera();
        } else if (!this.esperando) {
            // ngModel escribe su valor inicial en una microtarea: si se actúa antes, el select aún está vacío y la
            // primera opción pisaría ese valor en el componente mientras el select muestra el original.
            this.esperando = true;
            Promise.resolve().then(() => Promise.resolve()).then(() => {
                this.listo = true;
                this.mostrarPrimera();
            });
        }
    }

    private mostrarPrimera(): void {
        const select = this.select;
        const valor = select.modelValue();
        if (!this.autoDisplayFirst || select.editable || select.placeholder?.() || (valor !== null && valor !== undefined)) {
            return;
        }
        const primera = select.visibleOptions()[select.findFirstOptionIndex()];
        if (primera) {
            // Sin emitir onChange ni cerrar el panel, igual que la 16
            select.onOptionSelect(null, primera, false, true);
        }
    }
}
